/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Otherlanguages_Level_Placeholder1Inputs */

const en_otherlanguages_level_placeholder1 = /** @type {(inputs: Otherlanguages_Level_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language level`)
};

const de_otherlanguages_level_placeholder1 = /** @type {(inputs: Otherlanguages_Level_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachniveau`)
};

/**
* | output |
* | --- |
* | "Language level" |
*
* @param {Otherlanguages_Level_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const otherlanguages_level_placeholder1 = /** @type {((inputs?: Otherlanguages_Level_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Otherlanguages_Level_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_otherlanguages_level_placeholder1(inputs)
	return en_otherlanguages_level_placeholder1(inputs)
});
export { otherlanguages_level_placeholder1 as "otherLanguages_level_placeholder" }